import { connect } from 'react-redux';
import Modal from 'comp/modals/join_group';
import { cache } from 'utils';

const mapToProps = state => ({
  status: state.fetch.group_join || cache.empty_obj
});

export default connect(mapToProps)(Modal);



// WEBPACK FOOTER //
// ./src/containers/modals/JoinGroup.js